import React from 'react';
import { Animate } from 'react-move';
import { renderChildren } from '@fiverr-private/ui_utils';
import { SlideFadeProps, TransitionProps } from '../../types';
import variants from './variants';

const SlideFade = ({
  reverse = true,
  offsetX = 'none',
  offsetY = 'sm',
  delay,
  duration = 'moderate1',
  easing = { enter: 'easeIn', exit: 'easeOut' },
  unmountOnExit,
  in: isOpen,
  children,
}: TransitionProps & SlideFadeProps) => {
  const custom = { offsetX, offsetY, reverse, delay, duration, easing };

  return (
    <Animate
      show={unmountOnExit ? isOpen : true}
      start={variants.exit(custom)}
      enter={() => (isOpen ? variants.enter(custom) : variants.exit(custom))}
      update={() => (isOpen ? variants.enter(custom) : variants.exit(custom))}
      leave={variants.exit(custom)}
    >
      {({ x, y, ...rest }) =>
        renderChildren(children, {
          style: {
            ...(children.props.style || {}),
            ...rest,
            display: rest.opacity === 0 ? 'none' : undefined,
            transform: isOpen || reverse ? `translate(${x}px,${y}px)` : undefined,
          },
        })
      }
    </Animate>
  );
};

SlideFade.displayName = 'SlideFade';

export default SlideFade;
